var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedArrowSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.116 10.884a1.25 1.25 0 001.768 0l7.955-7.955A1.25 1.25 0 1017.07 1.16L10 8.232l-7.071-7.07A1.25 1.25 0 001.16 2.928l7.955 7.955zM8.75 9v1h2.5V9h-2.5z",
    fill: "#8E8E8E"
  })));
}

export default SvgLedArrowSelect;